import { render, staticRenderFns } from "./FarmaciaSalidas.vue?vue&type=template&id=1e3cffd5&"
import script from "./FarmaciaSalidas.vue?vue&type=script&lang=js&"
export * from "./FarmaciaSalidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports